<template>
    <div id="wrapper" class="font-fira">
      <TextHeader :headerTitle="$t('cathedrals.title')" />
      <div id="content" class="w-container">
        <p class="paragraph" v-html="$t('cathedrals.p1')" />
        <img src="https://madrigal-public.s3.eu-central-1.amazonaws.com/artsafari2023/cathedrals/01.jpg" alt="Madrigal Choir in a cathedral"/>
        <p class="section-heading" v-html="$t('cathedrals.s1')" />
        <div class="underline-bar"></div>
        <p>1973</p>
        <ul>
            <li v-html="$t('cathedrals.c1')" />
        </ul>
        <p>1978</p>
        <ul>
            <li v-html="$t('cathedrals.c2')" />
        </ul>
        <p>1992</p>
        <ul>
            <li v-html="$t('cathedrals.c3')" />
        </ul>
        <p>1993</p>
        <ul>
            <li v-html="$t('cathedrals.c4')" />
            <li v-html="$t('cathedrals.c5')" />
            <li v-html="$t('cathedrals.c6')" />
        </ul>
        <p>1994</p>
        <ul>
            <li v-html="$t('cathedrals.c7')" />
            <li v-html="$t('cathedrals.c8')" />
            <li v-html="$t('cathedrals.c9')" />
        </ul>
        <p>1995</p>
        <ul>
            <li v-html="$t('cathedrals.c10')" />
        </ul>
        <p>1996</p>
        <ul>
            <li v-html="$t('cathedrals.c11')" />
        </ul>
        <p>1997</p>
        <ul>
            <li v-html="$t('cathedrals.c12')" />
            <li v-html="$t('cathedrals.c13')" />
        </ul>
        <p>1998</p>
        <ul>
            <li v-html="$t('cathedrals.c14')" />
            <li v-html="$t('cathedrals.c15')" />
        </ul>
        <p>1999</p>
        <ul>
            <li v-html="$t('cathedrals.c16')" />
        </ul>
        <p>2001</p>
        <ul>
            <li v-html="$t('cathedrals.c17')" />
        </ul>
        <p>2002</p>
        <ul>
            <li v-html="$t('cathedrals.c18')" />
            <li v-html="$t('cathedrals.c19')" />
            <li v-html="$t('cathedrals.c20')" />
        </ul>
        <p>2003</p>
        <ul>
            <li v-html="$t('cathedrals.c21')" />
        </ul>
        <p>2006</p>
        <ul>
            <li v-html="$t('cathedrals.c22')" />
        </ul>
        <p>2008</p>
        <ul>
            <li v-html="$t('cathedrals.c23')" />
            <li v-html="$t('cathedrals.c24')" />
            <li v-html="$t('cathedrals.c25')" />
        </ul>
        <p>2009</p>
        <ul>
            <li v-html="$t('cathedrals.c26')" />
            <li v-html="$t('cathedrals.c27')" />
            <li v-html="$t('cathedrals.c28')" />
        </ul>
        <p>2011</p>
        <ul>
            <li v-html="$t('cathedrals.c29')" />
            <li v-html="$t('cathedrals.c30')" />
        </ul>
        <p>2012</p>
        <ul>
            <li v-html="$t('cathedrals.c31')" />
            <li v-html="$t('cathedrals.c32')" />
        </ul>
        <p>2013</p>
        <ul>
            <li v-html="$t('cathedrals.c33')" />
            <li v-html="$t('cathedrals.c34')" />
        </ul>
        <p>2014</p>
        <ul>
            <li v-html="$t('cathedrals.c35')" />
        </ul>
        <p>2015</p>
        <ul>
            <li v-html="$t('cathedrals.c36')" />
            <li v-html="$t('cathedrals.c37')" />
        </ul>
        <p>2016</p>
        <ul>
            <li v-html="$t('cathedrals.c38')" />
            <li v-html="$t('cathedrals.c39')" />
            <li v-html="$t('cathedrals.c40')" />
            <li v-html="$t('cathedrals.c41')" />
            <li v-html="$t('cathedrals.c42')" />
        </ul>
        <p>2017</p>
        <ul>
            <li v-html="$t('cathedrals.c43')" />
            <li v-html="$t('cathedrals.c44')" />
            <li v-html="$t('cathedrals.c45')" />
            <li v-html="$t('cathedrals.c46')" />
        </ul>
        <p>2018</p>
        <ul>
            <li v-html="$t('cathedrals.c47')" />
            <li v-html="$t('cathedrals.c48')" />
            <li v-html="$t('cathedrals.c49')" />
            <li v-html="$t('cathedrals.c50')" />
            <li v-html="$t('cathedrals.c51')" />
        </ul>
        <p>2019</p>
        <ul>
            <li v-html="$t('cathedrals.c52')" />
        </ul>
        <p>2021</p>
        <ul>
            <li v-html="$t('cathedrals.c53')" />
            <li v-html="$t('cathedrals.c54')" />
        </ul>
        <p>2022</p>
        <ul>
            <li v-html="$t('cathedrals.c55')" />
            <li v-html="$t('cathedrals.c56')" />
            <li v-html="$t('cathedrals.c57')" />
        </ul>
        <img src="https://madrigal-public.s3.eu-central-1.amazonaws.com/artsafari2023/cathedrals/02.jpg" alt="Madrigal Choir in a cathedral in Lyon"/>
      </div>
    </div>
  </template>
  <script>
    import TextHeader from "./TextHeader";
    export default {
      name: "Cathedrals",
      components: { TextHeader },
      data() {}
    }
  </script>
  <style style scoped lang="scss">
    #content {
      font-family: Fira Sans,sans-serif;
      font-size: 1.3em;
      line-height: 25px;
      font-weight: 400;
      padding: 60px 0;
    }
  
    @media screen and (max-width: 1155px) {
      #content {
        padding: 60px 7px;
      }
    }
  
    .paragraph {
      line-height: 30px;
      font-weight: 600;
      margin-bottom: 30px;
    }
  
    .section-heading {
      font-size: 1.4em;
      line-height: 45px;
      margin-bottom: 10px;
      margin-top: 30px;
      font-weight: bold;
    }
  
    .underline-bar {
      background-color: #333;
      height: 3px;
      width: 120px;
      margin-bottom: 20px;
    }

    p {
        font-weight: 600;
    }
  </style>